import {gsap} from "gsap";
import {BitmapCountUp} from "@nolimitcity/slot-game/bin/component/BitmapCountUp";
import {BitmapTextStyleOptions, TextStyleOptions} from "../../../../../core/setting/text/IText";
import {GameAssets} from "../../../../config/texture/GameAssets";
import {PunkRocker} from "../../../../PunkRocker";

export class NJReqIndividualWinView extends PIXI.Container {
    private readonly _winWays: PIXI.Text;
    private readonly _winAmountBitmap: BitmapCountUp;
    private readonly _winAmountNumber: number;

    private readonly _countUpStyle: BitmapTextStyleOptions = {
        fontName: GameAssets.BITMAP_FONT_WIN_COUNT_UP_LOW,
        fontSize: 24,
        align: "center",
        maxWidth: 110,
        letterSpacing: 0
    };

    private readonly _waysTextStyle: TextStyleOptions = {
        dropShadow: true,
        dropShadowAngle: 7.5,
        fill: "white",
        fontFamily: "Helvetica",
        fontSize: 16,
        fontStyle: "italic",
        fontWeight: "bold",
        miterLimit: 0,
        strokeThickness: 1
    };

    constructor(winAmount: number, winWays: number, position: PIXI.Point) {
        super();
        this.visible = false;

        this._winAmountNumber = winAmount;
        this._winAmountBitmap = new BitmapCountUp(this._countUpStyle);
        this._winAmountBitmap.maxTextWidth = 110;
        this._winAmountBitmap.shrinkSize = true;
        this._winAmountBitmap.getCountUpAnimation(this._winAmountNumber, this._winAmountNumber, 0.002);
        this._winAmountBitmap.position.set(0, 0);

        this._winWays = new PIXI.Text(winWays + " " + PunkRocker.apiPlugin.translations.translate(winWays === 1 ? "Way Won" : "Ways Won").toLowerCase());
        this._winWays.style = this._waysTextStyle;
        this._winWays.anchor.set(0.5);
        this._winWays.position.set(0, 30);

        this.position = position;
        this.addChild(this._winAmountBitmap, this._winWays);
    }

    public showWinAndWays(durr: number): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                this.visible = false;
            }
        });
        tl.add(() => {
            this.visible = true;
        });
        tl.to(this, {y: this.position.y - 90, duration: durr}, 0);
        tl.to(this, {
            alpha: 0,
            duration: 0.42 - (0.42 / 1.5)
        }, 0.42 / 1.5);
        return tl;
    }
}